import { useEffect, useState, useCallback } from "react";
import { Bell, BellOff } from "lucide-react";
import { isPushSupported, subscribePush, unsubscribePush, getPushStatus, ensureSwRegistered } from "@/lib/push";

export default function PushToggle() {
  const [status, setStatus] = useState({ supported: false, subscribed: false, permission: "default" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    const s = await getPushStatus();
    setStatus(s);
  }, []);

  useEffect(() => {
    ensureSwRegistered().then(() => refresh());
  }, [refresh]);

  if (!isPushSupported() || !status.supported) {
    return null;
  }

  const onClick = async () => {
    setBusy(true);
    setError("");
    try {
      if (status.subscribed) {
        await unsubscribePush();
      } else {
        await subscribePush();
      }
      await refresh();
    } catch (e) {
      setError(e.message || "Erreur");
    } finally {
      setBusy(false);
    }
  };

  const denied = status.permission === "denied";

  return (
    <div className="inline-flex flex-col items-end gap-1" data-testid="push-toggle">
      <button
        type="button"
        onClick={onClick}
        disabled={busy || denied}
        className={`inline-flex items-center gap-2 px-3 py-2 rounded-full text-sm font-semibold border transition-colors ${
          status.subscribed
            ? "bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-100"
            : "bg-white text-[var(--ink)] border-[var(--line)] hover:bg-orange-50"
        } ${denied ? "opacity-60 cursor-not-allowed" : ""}`}
        data-testid="push-toggle-btn"
        title={denied ? "Notifications bloquees par le navigateur" : ""}
      >
        {status.subscribed ? <Bell size={14} /> : <BellOff size={14} />}
        <span className="hidden sm:inline">
          {denied
            ? "Notifications bloquees"
            : status.subscribed
              ? "Notifications activees"
              : busy
                ? "..."
                : "Activer les notifications"}
        </span>
      </button>
      {error && <span className="text-xs text-red-600" data-testid="push-error">{error}</span>}
    </div>
  );
}
